(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvSeeMore', drvSeeMore);

    drvSeeMore.$inject = [];
    drvSeeMoreCtrl.$inject = ['$element', '$filter'];

    /**
     * Initially shows a condensed version of the supplied text, with the ability to expand the view.
     *
     * # Scope Properties
     * {string} text - The text to be shown
     */
    function drvSeeMore() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvSeeMoreCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                text: '<'
            },
            template:
                '<div>' +
                '   <p>' +
                '       {{drvCtrl.showAll ? drvCtrl.text : drvCtrl.condensedText}}' +
                '   </p>' +
                '   <p><a ng-if="drvCtrl.text.length > drvCtrl.condensedText.length" href="" ng-click="drvCtrl.showAll = !drvCtrl.showAll">{{drvCtrl.buttonLabel}}</a></p>' +
                '</div>'
        };
        return directive;
    }

    function drvSeeMoreCtrl($element, $filter) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.showAll = false;
        var rows = 3;
        var characterWidth = 8;
        var reservedCharacterLength = 11;
        Object.defineProperty(drvCtrl, 'condensedText', { get: getCondensedText });
        Object.defineProperty(drvCtrl, 'buttonLabel', { get: function () { return drvCtrl.showAll ? 'See Less' : 'See More'; } });

        /**
         * Get the condensed version of the text
         */
        function getCondensedText() {
            // If the element has no width set, don't condense the text. This is done so the 'See More' label isn't shown when loading a view/tab.
            if ($element[0].firstElementChild.clientWidth === 0) {
                return drvCtrl.text;
            }

            var availableWidth = $element[0].firstElementChild.clientWidth;
            var availableCharacterLength = ((availableWidth * rows) / characterWidth) - reservedCharacterLength;

            return $filter('limitTo')(drvCtrl.text, availableCharacterLength);
        }
    }
})();